import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { OrganizationNewsComponent } from "../../../../standalone/organization-news/organization.news.component";
import { S25Util } from "../../../../util/s25-util";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-news-widget",
    template: `
        @if (orgStore.orgId()) {
            <s25-ng-organization-news
                [orgId]="orgStore.orgId()!"
                [readonly]="true"
                [limit]="limit()"
                [hideHeading]="hideHeading()"
                [headingLevel]="headingLevel()"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [OrganizationNewsComponent],
})
export class SeOrgNewsWidgetComponent extends LayoutWidget<typeof SeOrgNewsWidgetComponent> {
    static readonly META = {
        name: "News",
        info: "Displays the organization news feed.",
        settings: [
            { id: "limit", label: "Max articles", type: "field" as const, fieldType: "text" as const },
            {
                id: "hideHeading",
                label: "Hide section heading",
                type: "field" as const,
                fieldType: "checkbox" as const,
            },
        ],
        defaultSettings: {
            limit: "5",
            hideHeading: "false",
        },
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);

    protected readonly limit = computed(() => S25Util.parseInt(this.settingValues()["limit"]) ?? 5);
    protected readonly hideHeading = computed(() => this.settingValues()["hideHeading"] === "true");
    protected readonly headingLevel = computed(() => (this.hideHeading() ? 2 : 3));
}
